import * as React from "react";
import { Outlet } from "react-router";
import { Box, Typography } from "@mui/material";
import { SignInButton } from "../common/NavBar/SignInButton";

/**
 * @function LayoutClosedSession
 * @description Layout se renderiza duando el usuario cierra session.
 * @returns {React.JSX.Element}
 */
export default function LayoutClosedSession (): React.JSX.Element {
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
                width: "100vw",
                height: "100vh",
                overflow: "none",
                overflowY: "auto",
            }}
        >
            <Box
                borderRadius={3}
                borderColor="secondary.light"
                sx={{
                    width: "50vw",
                    padding: 2,
                    display: 'inline-block',
                    textAlign: "center",
                    margin:"auto",
                    borderStyle: "solid",
                    borderWidth: "1px",
                }}
            >
                <Typography variant="h1" gutterBottom>
                    Techint
                </Typography>
                <Typography variant="h3" gutterBottom>
                    Closed Session
                </Typography>
                <hr />
                <SignInButton />
                <Outlet />
            </Box>
        </Box>
    )
}
